module.exports = __webpack_public_path__ + "img/a855df93a36c4a9085c781837083ba9a.fb78fdb9.png";